import { Box, IconButton, Paper, styled, Typography } from "@mui/material";

// Styled Components
export const ChatPaper = styled(Paper)(({ theme }) => ({
  display: "flex",
  zIndex: 9998,
  flexDirection: "column",
  height: "100%",
  padding: "15px",
  transition: "all 0.5s ease-in-out",
}));

export const MessagesContainer = styled("div")({
  flexGrow: 1,
  overflowY: "auto",
  overflowX: "hidden",
  padding: "8px",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  borderRadius: 8,
  background: "#f5f5f5",
  maxWidth: "100%",
  wordBreak: "break-word",
  scrollbarWidth: "thin",
  scrollbarColor: "#b0b0b0 #f5f5f5",
});

export const MessageBox = styled("div")(({ theme }) => ({
  marginBottom: "6px",
  padding: "5px 8px",
  fontSize: "13px",
  background: "#fff",
  borderRadius: "6px",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  position: "relative", // Asegura que podamos posicionar la fecha dentro de este contenedor
}));

export const FileLink = styled("span")({
  textDecoration: "none",
  cursor: "pointer",
});

export const FileStatus = styled("span")({
  position: "absolute",
  top: 0,
  right: 0,
  backgroundColor: "red",
  color: "white",
  borderRadius: "50%",
  padding: "4px",
  fontSize: "8px",
});

export const SendMessageContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  paddingTop: "10px",
});

export const SendButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: "rgba(42, 93, 247, 0.75)",
  color: "white",
  "&:hover": {
    backgroundColor: "rgba(42, 93, 247, 0.9)",
  },
}));

export const FechaHoraEnvio = styled("p")({
  position: "absolute",
  bottom: "5px",
  right: "10px",
  fontSize: "11px",
  color: "#777",
});

export const Header = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
  justifyContent: "space-between"
}));

export const HeaderTitleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
});

export const IconWrapper = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.primary.contrastText,
  boxShadow: theme.shadows[1],
}));

export const TitleBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const TitleTypography = styled(Typography)({
  fontWeight: 700,
  lineHeight: 1,
});

export const CaptionTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const ChatConnectionStateContainer = styled('div')(({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
}));

export const CloseChatButton = styled(IconButton)(({ theme }) => ({
  padding: "10px",
  border: "none",
  color: theme.palette.primary.contrastText,
}));

export const ChatMessage = styled('p')({
  margin: 0,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  paddingRight: '30px'
});